<div class="shadow-sm navbar-mobile" *ngIf="showBanner">
  <div nz-row>
    <div nz-col nzXs="6">
      <a>
        <img
          src="https://images.prismic.io/lipatinpdn/45174b3e-e9e7-4672-95bc-c554c511f14e_Logo+Liga+de+Patinaje+de+Antioquia_Mesa+de+trabajo+1.png?auto=compress,format"
          alt="Logo Lipatin"
          width="80"
        />
      </a>
    </div>
    <div class="text-success navbar-mobile__title" nz-col nzXs="12">
      Plataforma de Vinculaciones
      <label class="text-muted">| {{ club.name }}</label>
    </div>
    <div nz-col class="text-success navbar-mobile__user" nzXs="6">
      <a nz-dropdown [nzDropdownMenu]="menu">
        <i nz-icon nzType="menu"></i>
      </a>
      <nz-dropdown-menu #menu="nzDropdownMenu">
        <ul nz-menu nzSelectable>
          <li *ngIf="userName" (click)="logout()" nz-menu-item>Cerrar Sesión</li>
        </ul>
      </nz-dropdown-menu>
    </div>
  </div>

</div>

<nav class="navbar navbar-light main-header shadow-sm" *ngIf="showBanner">
  <a class="navbar-brand text-dark" href="#">
    <img
      src="https://images.prismic.io/lipatinpdn/45174b3e-e9e7-4672-95bc-c554c511f14e_Logo+Liga+de+Patinaje+de+Antioquia_Mesa+de+trabajo+1.png?auto=compress,format"
      alt="Logo Lipatin"
      width="120"
      class="d-inline-block align-text-top"
    />
  </a>

  <div class="main-header__title">
    <div class="lead text-success m-2">
      Plataforma de Vinculaciones
      <label class="text-muted">| {{ club.name }}</label>
    </div>

    <div class="main-header__user">
      <a nz-dropdown [nzDropdownMenu]="menu">
        {{ userName }}
        <i nz-icon nzType="down"></i>
      </a>
      <nz-dropdown-menu #menu="nzDropdownMenu">
        <ul nz-menu nzSelectable>
          <li *ngIf="userName" (click)="logout()" nz-menu-item>
            Cerrar Sesión
          </li>
        </ul>
      </nz-dropdown-menu>
    </div>
  </div>
</nav>
